import {createSelector} from '@reduxjs/toolkit'

import {map} from '@shared/helpers/collection'
import {entries, get} from '@shared/helpers/object'

import type {Merchant, MerchantNo, RootState} from './interfaces'

export const merchantsSelector = (state: RootState) => state.merchants

type MerchantEntries = Array<[MerchantNo, Merchant]>

const merchantsEntriesSelector = createSelector(merchantsSelector, (state): MerchantEntries => entries(state))

type MerchantItem = Merchant & {merchantNo: number}
type MerchantList = Array<MerchantItem>

/**
 * Merchants Records 를 Array 로 변환하여 반환합니다.
 * - 이때 merchantNo 필드를 추가하고, Record key(MerchantNo) 을 number 타입으로 할당합니다.
 */
export const merchantListSelector = createSelector(merchantsEntriesSelector, (merchantsEntries): MerchantList => {
    return merchantsEntries.map(([merchantNo, value]) => {
        return {
            ...value,
            merchantNo: parseInt(merchantNo, 10),
        }
    })
})

export const merchantNameListSelector = createSelector(merchantsEntriesSelector, map(get([1, 'name'])))

/**
 * @deprecated
 * 첫번째 merchant 정보 중 merchantId 를 반환합니다.
 * - `cpid` 와 같은 특정 서비스 용어가 포함되어 있으므로 개선이 필요합니다.
 * - firstMerchantIDSelector 를 사용해주세요.
 */
export const merchantCpidSelector = createSelector(merchantsSelector, (merchant) => {
    return merchant[0]?.merchantId ?? ''
})

/**
 * 하나의 Merchant 정보를 반환합니다.
 */
export const singleMerchantSelector = createSelector(
    merchantListSelector,
    (state): ItemType<MerchantList> | undefined => get([0])(state),
)
